// extracted by css-extract-rspack-plugin
export default {"PermissionTableContainer":"EmTLr"};